<template>
  <div class="results-list ml-0 ml-md-2">
    <div
      class="d-flex flex-sm-row flex-column justify-space-between align-sm-center align-start mx-2"
    >
      <div
        class="results-list__count-container text-truncate mb-sm-0 mb-5"
        role="status"
        aria-atomic="true"
      >
        <h2 class="results-list__count-heading subtitle-1 px-0">
          <span>
            <strong v-if="showResults || sortIsChanged">{{
              totalCount
            }}</strong>
            <span v-else>Searching</span>
            results
          </span>
          <span v-if="searchTerm !== undefined && searchTerm.length > 0">
            for
            <span class="d-sr-only">search term:</span>
            <strong>{{ searchTerm }}</strong>
          </span>
          <span v-if="facetList" aria-hidden="true">in {{ facetList }}</span>
          <span v-if="facetListSR" class="d-sr-only">in {{ facetListSR }}</span>
          <span v-if="!searchTerm && !facetListSR" class="d-sr-only">
            (no filters selected)
          </span>
          <span v-if="selectedSortName" class="d-sr-only">
            sorted by {{ selectedSortName }}
          </span>
        </h2>
      </div>
      <SortDropdown
        v-if="showSearchDashboardSortDropdown"
        id="search-dashboard-sort-dropdown"
        name="search-dashboard-sort-dropdown"
        :sort-options="sortOptions"
        :default-sort="defaultSort"
        @sortChanged="sortChanged"
      />
    </div>
    <div v-if="showResults" class="mt-4">
      <MatchResult
        v-for="result in results"
        :key="result.item.id"
        :article="result.item"
        :highlight="result.highlight"
      />
    </div>
  </div>
</template>

<script>
import MatchResult from "~/components/matches/MatchResult.vue";
import SortDropdown from "~/components/matches/components/SortDropdown.vue";
import mapFlags from "~/plugins/utilities/mapFlags";

export default {
  name: "ResultsList",
  components: {
    MatchResult,
    SortDropdown,
  },
  props: {
    showResults: { type: Boolean, default: false },
    totalCount: { type: Number, required: true },
    searchTerm: { type: String, default: undefined },
    facets: { type: Object, default: undefined },
    results: { type: Array, required: true },
    sortOptions: { type: Array, required: true },
    defaultSort: { type: String, required: true },
    sortIsChanged: { type: Boolean, default: false },
  },
  data() {
    return {
      selectedSortName: "",
    };
  },
  computed: {
    ...mapFlags(["showSearchDashboardSortDropdown"]),
    facetList() {
      const facets = Object.keys(this.facets).map((key) => {
        return this.facets[key].items;
      }, this);

      return facets.flat().join(", ");
    },
    facetListSR() {
      // eslint-disable-next-line array-callback-return
      const facetsSR = Object.keys(this.facets).map((key) => {
        if (this.facets[key].items.length)
          return `${this.facets[key].name}: ${this.facets[key].items.join(
            ", "
          )}`;
      }, this);

      return facetsSR
        .flat()
        .filter((result) => result)
        .join(", ");
    },
  },
  created() {
    const sortByQuery = this.$route.query.sortBy;
    this.selectedSortName = this.sortOptions.find(
      (option) => option.key === sortByQuery
    )?.name;
  },
  methods: {
    sortChanged(selectedSort) {
      this.$emit("sortChanged", selectedSort);
      this.selectedSortName = this.sortOptions.find(
        (option) => option.key === selectedSort
      )?.name;
    },
  },
};
</script>

<style lang="scss">
.results-list {
  .nudge-up {
    vertical-align: super;
  }

  .v-btn {
    margin-right: 0;
    margin-top: 0;
  }

  &__count-heading {
    white-space: normal;
  }

  &__count-container {
    max-width: 100%;
  }
}
</style>
